import { combineReducers } from '@reduxjs/toolkit';
import { createFetchReducer } from 'store/setLocalStore';
import session from './eVisitSession';
import * as actions from '../actions';

export default combineReducers({
  session,
  eligibility: createFetchReducer(actions.CHECK_E_VISIT_ELIGIBILITY, true)
});
